<template>
	<el-dialog
		:class="noBottomPadding ? 'modal-no-bottom-padding' : ''"
		:top="top"
		@close="$emit('close')"
		:visible="isVisible"
		direction="rtl"
		:width="width"
		:append-to-body="appendToBody"
	>
		<div class="modalBody">
			<slot />
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		appendToBody: Boolean,
		noBottomPadding: Boolean,
		visible: Boolean,
		width: {
			type: String,
			default() {
				return "600px";
			},
		},
		top: {
			type: String,
			default() {
				return "15vh";
			},
		},
	},
	computed: {
		isVisible() {
			return this.visible;
		},
	},
};
</script>

<style scoped>
.modalBody {
	padding-left: 40px;
	padding-right: 40px;
}

.modal-no-bottom-padding /deep/ .el-dialog__body {
	padding-bottom: 0px !important;
}
</style>
